import {PAGES} from "../../core/consts";

export const BETTING_CONTAINER = {
  SECONDARY_ITEM_SCALE: 0.8,
  ITEMS_GAP: 16,
  BETTING_ZONE_BASE_URL: '/apostas',

  ACTION_TYPES: {
    onActiveMenuButton: 'onActiveMenuButton',
    onActiveAnchorButton: 'onActiveAnchorButton',
    breadcrumbsPopulate: 'breadcrumbsPopulate',
    bettingZonePopulateData: 'bettingZonePopulateData',
    stickyOfferVisibilityChange: 'stickyOfferVisibilityChange',
    globalStickyOfferHandler: 'globalStickyOfferHandler',
  },

  API_FILTERS: {
    siteSettings: 'sitesettings',
    homePage: 'homepage',
    bettingSites: 'betting-sites',
    bookies: 'bookies',
    posts: 'posts',
    content: 'content',
    howToBet: 'how-to-bet'
  },

  SITE_HEADER_BUTTONS: {
    mediumBar: 5,
    largeBar: 7,
  },

  ARTICLE_ITEM_WIDTH: {
    desktop: 512,
    mobile: 293,
  },

  MENU_ANCHORS_OFFSET: {
    desktop: 120,
    mobile: 88
  },

  MINIMUM_BOOKIES_CUBES: {
    mobile: 6,
    desktop: 6
  },

  CALCULATOR_ITEM_WIDTH: {
    desktop: 248,
    mobile: 248,
  },

  CALCULATORS_CAROUSEL: {
    CALCULATOR_ITEM_WIDTH: {
      desktop: 248,
      mobile: 248,
    },

    SECONDARY_ITEM_SCALE: 1,
    ITEMS_GAP: 64,
  },

  ANALYTICS: {
    ACTION_TYPES: {
      onPageViewHandler: 'onPageViewHandler'
    },

    TRAFFIC_SOURCE: {
      main: '365scores',
      direct: 'direct'
    },

    SOURCE: {
      bookiesCubes: 'bookies-cubes',
      bookiesTableComparison: 'bookies-table-comparison',
      accaWidget: 'acca-widget',
      stickyOffer: 'sticky-offer',
      specialOffer: 'special-offer',
      bonusSnippet: 'bonus-snippet',
      hero: 'hero',
      descriptionOffer: 'description-offer',
      todayPredictions: 'todays-predictions',
      promotionsSlider: 'promotions-slider',
      promotionsTable: 'promotions-table',
      accountStepper: 'account-stepper',
    },
    PAGES_CONTEXT_NAME: {
      [PAGES.BETTING.index]: 'HomePage',
      [PAGES.BETTING.bettingSites]: 'BettingSites',
      [PAGES.BETTING.article]: 'Article',
      [PAGES.BETTING.brandReview]: 'BrandReview',
      [PAGES.BETTING.howToBet]: 'HowToBet',
      betting: 'HomePage',
    },
    SCREEN_NAME: {
      homePage: 'homepage',
      article: 'article',
      bettingSites: 'bettingsites',
      brandReview: 'brandreview',
      howToBet: 'how-to-bet',
    },

    CONTEXT_SOURCE: {
      promotionstable: 'promotionstable',
      bonusSnippet: 'bonussnippet',
      promotionsSlider: 'promotionsslider',
      descriptionOffer: 'welcomeoffer',
      accountStepper: 'accountStepper',
    },
  }

};
